var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.6641V11.3307H14V12.6641H6ZM6 8.66406V7.33073H14V8.66406H6ZM6 4.66406V3.33073H14V4.66406H6ZM3.33333 13.3307C2.96667 13.3307 2.65278 13.2002 2.39167 12.9391C2.13056 12.678 2 12.3641 2 11.9974C2 11.6307 2.13056 11.3168 2.39167 11.0557C2.65278 10.7946 2.96667 10.6641 3.33333 10.6641C3.7 10.6641 4.01389 10.7946 4.275 11.0557C4.53611 11.3168 4.66667 11.6307 4.66667 11.9974C4.66667 12.3641 4.53611 12.678 4.275 12.9391C4.01389 13.2002 3.7 13.3307 3.33333 13.3307ZM3.33333 9.33073C2.96667 9.33073 2.65278 9.20017 2.39167 8.93906C2.13056 8.67795 2 8.36406 2 7.9974C2 7.63073 2.13056 7.31684 2.39167 7.05573C2.65278 6.79462 2.96667 6.66406 3.33333 6.66406C3.7 6.66406 4.01389 6.79462 4.275 7.05573C4.53611 7.31684 4.66667 7.63073 4.66667 7.9974C4.66667 8.36406 4.53611 8.67795 4.275 8.93906C4.01389 9.20017 3.7 9.33073 3.33333 9.33073ZM3.33333 5.33073C2.96667 5.33073 2.65278 5.20017 2.39167 4.93906C2.13056 4.67795 2 4.36406 2 3.9974C2 3.63073 2.13056 3.31684 2.39167 3.05573C2.65278 2.79462 2.96667 2.66406 3.33333 2.66406C3.7 2.66406 4.01389 2.79462 4.275 3.05573C4.53611 3.31684 4.66667 3.63073 4.66667 3.9974C4.66667 4.36406 4.53611 4.67795 4.275 4.93906C4.01389 5.20017 3.7 5.33073 3.33333 5.33073Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.2b3be4bf3237438adb9a14eb34a1f25d.svg";
export { ForwardRef as ReactComponent };